import React from "react";
import { withRouter } from "react-router-dom";
import moment from "moment";

import Footer from "../../Components/footer";
import CollapseCard from "./CollapseCard";
import Form from "./Form";
import "./CollapseCard.css";

import { renderRedirect } from "../../util";
import { updateSignApplication, fetchSignApplication } from "../BasicProfile/api";
import { validateForm } from "./Validations";

class AddNominee extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isValid: false,
            pincode: null,
            activeCard: "1",
        };
        for (let i = 1; i <= 10; i++) {
            this.state[`nominee${i}`] = null;
        }
    }

    async componentDidMount() {
        let profileData = await fetchSignApplication();
        if (profileData && profileData.data && profileData.data.fetch_signup_application) {
            let data = profileData?.data?.fetch_signup_application;
            let stateUpdate = {
                pincode: data?.permanentAddress ? data.permanentAddress.substring(data.permanentAddress.length - 6) : null,
            };
            if (data?.nominees && Array.isArray(data.nominees)) {
                data.nominees.forEach((nom, index) => {
                    let idx = index + 1;
                    if (idx <= 10) {
                        stateUpdate[`nominee${idx}`] = {
                            ...nom,
                            minor: !!nom.minor_guardian_info,
                            guardian_name: nom.minor_guardian_info?.guardian_name,
                            guardian_address: nom.minor_guardian_info?.guardian_address,
                            guardian_mobile: nom.minor_guardian_info?.guardian_mobile,
                            guardian_email: nom.minor_guardian_info?.guardian_email,
                            guardian_relationship: nom.minor_guardian_info?.guardian_relationship,
                            guardian_id_type: nom.minor_guardian_info?.guardian_id_type,
                            guardian_id_number: nom.minor_guardian_info?.guardian_id_number,
                        };
                    }
                });
            }
            this.setState(stateUpdate);
        }
    }

    handleAddNominee = (data) => {
        if (data && data.length <= 10) {
            if (data.length === 10) {
                return false;
            }
            let sum = data.reduce((accumulator, curValue) => {
                return accumulator + parseInt(curValue.percentage_of_share);
            }, 0);
            return 100 - sum !== 0 ? true : false;
        } else {
            return true;
        }
    };

    saveNominee() {
        let data = [];
        let totalPercentage = 0;

        for (let e = 1; e <= 10; e++) {
            let obj = this.state[`nominee${e}`];
            if (obj) {
                if (obj?.name) {
                    let validation = validateForm(obj, `nominee${e}`);
                    if (!validation.status) {
                        window.alert(validation.err);
                        return;
                    }

                    totalPercentage += parseInt(obj?.percentage_of_share || "0");

                    let payload = {};
                    payload.nominee_number = obj?.nominee_number ?? `${e}`;
                    payload.name = obj.name;
                    payload.percentage_of_share = obj?.percentage_of_share;
                    payload.relationship = obj.relationship;
                    payload.address = obj.address;
                    payload.mobile = obj.mobile;
                    payload.email = obj.email;
                    payload.id_type = obj.id_type;
                    payload.id_number = obj.id_number;
                    if (obj.minor) {
                        payload.dob_if_minor = obj?.dob_if_minor
                            ? obj?.dob_if_minor.split("-").reverse().join("/")
                            : moment().format("DD/MM/YYYY");
                        payload.minor_guardian_info = {
                            guardian_name: obj.guardian_name,
                            guardian_address: obj.guardian_address,
                            guardian_mobile: obj.guardian_mobile,
                            guardian_email: obj.guardian_email,
                            guardian_relationship: obj.guardian_relationship,
                            guardian_id_type: obj.guardian_id_type,
                            guardian_id_number: obj.guardian_id_number,
                        };
                    }
                    data.push(payload);
                }
            }
        }

        if (data.length) {
            if (totalPercentage !== 100) {
                window.alert(`Total nominee share must sum to exactly 100%. Currently it is ${totalPercentage}%.`);
                return;
            }
            return this.updateNomineeDetails(data);
        } else {
            window.alert("Please fill at least one nominee details.");
        }
    }

    async updateNomineeDetails(data) {
        if (data.length) {
            let reqParam = {
                nominee_form_pincode: this.state.pincode,
                nominees: data,
            };
            let updateProfile = await updateSignApplication(reqParam);
            if (!updateProfile?.data) {
                return window.alert(updateProfile?.errors[0]?.message || "Something Went Wrong");
            } else {
                return renderRedirect(this.props, "/bank-cheque");
            }
        }
        return;
    }

    handleUserInput = (nomineeKey) => (event) => {
        const name = event.target.name;
        switch (name) {
            default:
                let data = { [event.target.name]: event.target.value };
                this.setState({
                    [nomineeKey]: { ...this.state[nomineeKey], ...data },
                });
                break;
        }
    };

    handleSetState = (nomineeKey) => (key, value) => {
        let data = { [key]: value };
        if (key === "minor") {
            let nomineeState = { ...this.state[nomineeKey] };
            if (!value) {
                let fields = [
                    "dob_if_minor",
                    "guardian_name",
                    "guardian_address",
                    "guardian_mobile",
                    "guardian_email",
                    "guardian_relationship",
                    "guardian_id_type",
                    "guardian_id_number",
                ];
                fields.forEach((e) => delete nomineeState[e]);
            }
            this.setState({
                [nomineeKey]: { ...nomineeState, ...data },
            });
        } else {
            this.setState({
                [nomineeKey]: { ...this.state[nomineeKey], ...data },
            });
        }
    };

    handleActiveCard = (value) => {
        if (value === this.state.activeCard) {
            this.setState({ activeCard: value });
        } else {
            let valInt = parseInt(value);
            if (valInt === 1) {
                this.setState({ activeCard: value });
            } else {
                let prevVal = valInt - 1;
                if (this.state[`nominee${prevVal}`]) {
                    if (parseFloat(this.fetchPercentage(value)) > 0) {
                        this.setState({ activeCard: value });
                    }
                }
            }
        }
    };

    fetchPercentage = (e) => {
        let total = 100;
        for (let i = 1; i <= 10; i++) {
            if (i.toString() !== e) {
                let nom = this.state[`nominee${i}`];
                if (nom?.percentage_of_share) {
                    total = total - parseFloat(nom.percentage_of_share);
                }
            }
        }
        return total.toString();
    };

    render() {
        const nomineeKeys = Array.from({ length: 10 }, (_, i) => `nominee${i + 1}`);
        const hasAnyNominee = nomineeKeys.some(key => this.state[key] !== null);

        return (
            <div className="col-md-6 col-lg-5 col-xl-4">
                <div className="container my-auto py-4 bg-white shadow-lg rounded">
                    <div className="row mt-2">
                        <div className="col-11 col-lg-11 mx-auto">
                            <h1>Nominee Details</h1>
                            <div className="nominee-form">
                                {Array.from({ length: 10 }, (_, i) => (i + 1).toString()).map((e) => {
                                    return (
                                        <CollapseCard
                                            key={e}
                                            active={this.state.activeCard === e}
                                            onClick={() => this.handleActiveCard(e)}
                                            title={`Nominee ${e}`}
                                            content={
                                                <Form
                                                    state={this.state[`nominee${e}`]}
                                                    handleState={this.handleSetState(`nominee${e}`)}
                                                    handleUserInput={this.handleUserInput(`nominee${e}`)}
                                                    maxPercentage={this.fetchPercentage(e)}
                                                />
                                            }
                                        />
                                    );
                                })}
                            </div>
                            <button
                                className="btn btn-primary btn-block text-uppercase mt-4"
                                type="button"
                                onClick={() => this.saveNominee()}
                                disabled={!hasAnyNominee}
                            >
                                Next
                            </button>
                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}
export default withRouter(AddNominee);
